import DestinationContent from "./DestinationContent";
import DestinationImage from "./DestinationImage";

export interface DestinationSectionProps {
  destination: string;
  headline: JSX.Element | string;
  description: string;
  highlights: {
    icon: JSX.Element;
    text: string;
  }[];
  imageSrc: string;
  imageAlt?: string;
  layoutVariant: "default" | "reversed";
  fromColor?: string;
  toColor?: string;
}

export const DestinationSection: React.FC<DestinationSectionProps> = ({
  headline,
  description,
  destination,
  highlights,
  imageSrc,
  imageAlt,
  layoutVariant,
  fromColor,
  toColor,
}) => {
  return (
    <div className="bg-white my-12">
      <div className="px-6 py-16">
        <div
          className={`md:flex gap-8 ${layoutVariant === "reversed" ? "flex-row-reverse" : "flex-row"} items-center max-w-7xl mx-auto`}
        >
          <DestinationContent
            headline={headline}
            description={description}
            destination={destination}
            highlights={highlights}
          />
          <DestinationImage
            src={imageSrc}
            alt={imageAlt}
            alignment={layoutVariant === "reversed" ? "left" : "right"}
            fromColor={fromColor}
            toColor={toColor}
          />
        </div>
      </div>
    </div>
  );
};

export default DestinationSection;
